module.exports = __webpack_public_path__ + "static/media/decibel-insight-webinars.24d1bf6f.md";